import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import PageWrapper from '../../components/PageWrapper'
import { ImportForm } from './form'

import './styles.css'

class ImportLicense extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <PageWrapper>
                <div className="container-fluid">
                    <ImportForm
                        type="license"
                        maxSizeBytes="1024000"
                        maxSizeBytesStr="1 MB"
                        maxSizeRows="200"
                        rowsPartition="10"
                        csvExample="audience_name,branded,alternative_id,description\nAudience test csv 1,1,a1,description 1\nAudience test csv 2,1,a2,descr 2\nAudience test csv 3,1,,\nAudience test csv 4,0,,description long description\n..."
                        goBack={() => (window.location.href = '/licenses')}
                    />
                </div>
            </PageWrapper>
        )
    }
}

export default connect(
    state => ({}),
    {
        goBack: () => push('/licenses')
    }
)(ImportLicense)
